/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/movie/shared/desktop/cast.js
 * In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
 * For ticket: GRINS-1507
 */

// fdRequire baggage: If you are in this file, please delete the next line and tidy up exports.
const module = { name: 'movie/shared/desktop/cast', exports: {} };
const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from '@take-2/fd-modules/splits/require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_debugLog as debugLog } from '@take-2/fd-modules/splits/require-core';



import { Splide as Splide } from '@take-2/fd-modules/splits/require-core';



const Selectors = {
    CAST_SLIDER: '#person-gallery-splide',
    CAST_CONTAINER: '#movie-details-person-container',
    CAST_LINKS: '.js-cast-carousel-item',
    CAST_NAV_BTNS: '.js-person-gallery-arrow-btn',
}
function onNavBtnClick() {
    track({
        event: EventTypes.GENERIC_CLICK,
        genericClickDetails: 'arrow clicks',
    });
}
function onCastClick() {
    track({
        event: EventTypes.PERFORMER_CLICK,
        performerName: this.dataset.name || '',
        performerID: this.dataset.id || '',
    });
}
function attach() {
    if (!document.querySelectorAll(Selectors.CAST_SLIDER)?.length) {
        debugLog.info(module.name, 'no slider');
        const container = document.querySelectorAll(Selectors.CAST_CONTAINER);
        return container?.length && ([...container].every(item => item.innerText = ''));
    }
    document.querySelectorAll(Selectors.CAST_LINKS)
        .forEach(item => item.addEventListener('click', onCastClick));
    document.querySelectorAll(Selectors.CAST_NAV_BTNS)
        .forEach(item => item.addEventListener('click', onNavBtnClick));
    new Splide(Selectors.CAST_SLIDER, {
        fixedWidth: '95px',
        fixedHeight: '175px',
        slideFocus: false,
        pagination: false,
    }).mount();
}
export default {
    attach
};
